import { getKeys } from './getKeys'

export const accessControlTranslations = {
  TITLE_PREFERENCES: '{{nominative}} Access Settings',
  ACCESS_CONTROL_DESCRIPTION: 'Control whether team members can view all {{nominative}} or only those assigned to them.',
  PRO_PLAN_INFO: 'If you choose ‘Only Assigned {{nominative}}’, the handovers will be disabled (Pro Plan only).',
  CHOSE_ACCESS_LEVEL: 'Choose access level:',
  SHOW_ALL: 'Show All {{nominative}}',
  ONLY_ASSIGNED: 'Show Only Assigned {{nominative}}',
  WHAT_IS_ACCESS_CONTROL: "What is ‘{{nominative}} Access Settings’?",
  WHAT_IT_DOES: "What this setting does:",
  SHOW_ALL_BULLET: "<strong>  ‘Show All {{nominative}}’</strong> - Carers can view every {{nominative}} in the app, even those they aren’t assigned to.",
  ONLY_ASSIGNED_BULLET: "<strong>‘Show Only Assigned {{nominative}}’</strong> - Carers only see {{nominative}} they've been assigned as their care team.",
  ROTA_BASED_ACCESS: "Rota Based Access",
  ROTA_BASED_ACCESS_DESCRIPTION: "When turned on, carers can only see {{nominative}} they have visits scheduled with in the 24 hours period plus any {{nominative}} on their care team. When turned off, carers revert to the primary access level chosen above (Show All vs. Only Assigned).",
  ROTA_BASED_ACCESS_INFO: "This option is only available if “Show Only Assigned {{nominative}}” is selected above.",
  WHAT_IS_ROTA_BASED_ACCESS: "What is ‘Rota Based Access’?",
  ROTA_BASED_ACCESS_EXPLANATION: "As your site has the rota feature you can choose to show {{nominative}} data based on your rota allocations using the setting below.",
  MY_RESIDENTS: "My {{nominative}}",
}

export const accessControlConstants = getKeys(accessControlTranslations)
